import { observable, action } from 'mobx';
import agent from '../api/agent';
import commonStore from './commonStore';
import navigatorStore from '../stores/navigatorStore';
class UserStore {
  @observable currentUser;
  @observable loadingUser;
  @observable updatingUser;
  @observable updatingUserErrors;
  // @observable loginDone = "false";
  loginDone = observable(false);

  // @action pullUser() {
  //   this.loadingUser = true;
  //   return agent.Auth.current()
  //     .then(action(({ user }) => { this.currentUser = user; }))
  //     .finally(action(() => { this.loadingUser = false; }))
  // }
  @action toggle(a) {
    this.loginDone = a;
  }

  @action setUser(user) {

    this.loadingUser = true;
    this.loginDone = true;
    if (window.localStorage.hasOwnProperty("userData")) {
      var image = window.localStorage.getItem("image") || require('../assets/default_picture.png');
      var display_name = window.localStorage.getItem("display_name");
      var profile_id = window.localStorage.getItem("profile_id");
      this.currentUser = {
        image, display_name: (display_name) ? display_name : "",
        profile_id
      }
      this.loadingUser = false;
    }
  }

  @action pulluser() {
    // console.log("pulluser")
    if (window.localStorage.hasOwnProperty("userData")) {
      var profile_id = window.localStorage.getItem("profile_id");
      if (window.localStorage.hasOwnProperty("userData")) {
        var image = window.localStorage.getItem("image") || require('../assets/default_picture.png');
        var display_name = window.localStorage.getItem("display_name");
        var profile_id = window.localStorage.getItem("profile_id");
        this.currentUser = {
          image, display_name,
          profile_id
        }
        this.loadingUser = false;

      }
      commonStore.setAppLoaded();
      return agent.Users.currentUser(window.localStorage.getItem("profile_id"))


    }
    else commonStore.setAppLoaded();

  }
  @action validateDisplayName(username) {
    return agent.Users.validateUserName(window.localStorage.getItem("profile_id"), username)
  }
  @action setErr(user) {

    this.loginErr = true;
    let { message } = user;
    navigatorStore.openErrorModal(message);



  }
  @action requestToEditUser(form, body, progressLoader) {
    // console.log(body)
    return agent.Users.editUser(window.localStorage.getItem("profile_id"), form, body, progressLoader)
  }
  @action requestToEditUserNoLoader(form, body) {
    // console.log(body)
    return agent.Users.editUserOnBlurr(window.localStorage.getItem("profile_id"), form, body)
  }
  @action updateUser(newUser) {
    this.updatingUser = true;
    return agent.Auth.save(newUser)
      .then(action(({ user }) => { this.currentUser = user; }))
      .finally(action(() => { this.updatingUser = false; }))
  }

  @action forgetUser() {
    this.currentUser = undefined;
  }

}
let userStore = new UserStore();
window.userStore = userStore;
export default userStore;


// WEBPACK FOOTER //
// ./src/stores/userStore.js